import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applyTheme } from './theme/themes'

applyTheme()

// No StrictMode. The double-mount it does in dev races with TipTap's
// DragHandle (Floating-UI portal DOM that React doesn't own) and with
// TipTap's internal postMessage scheduler, producing `removeChild`
// errors in unrelated components on doc load. The layer-filter store
// subscriptions we want to add compound the problem. Turning it off
// buys us a reliable mount; we trade the dev-mode idempotency checks
// for a working editor.
createRoot(document.getElementById('root')!).render(<App />)
